// extracted by mini-css-extract-plugin
export var clipBoardWrapper = "PartnerCenterTokenInfoBox-module__clipBoardWrapper___hN3H5";
export var description = "PartnerCenterTokenInfoBox-module__description___WCwAl";